import { Group, Pagination as MantinePagination } from '@mantine/core';
import './Pagination.css';

const VISIBLE_PAGE_COUNT = 5;

function getVisiblePages(current: number, total: number): number[] {
  const count = Math.min(VISIBLE_PAGE_COUNT, total);
  if (total <= VISIBLE_PAGE_COUNT) {
    return Array.from({ length: count }, (_, index) => index + 1);
  }

  let start: number;
  if (current <= 3) {
    start = 1;
  } else if (current >= total - 2) {
    start = total - VISIBLE_PAGE_COUNT + 1;
  } else {
    start = current - 2;
  }

  return Array.from({ length: VISIBLE_PAGE_COUNT }, (_, index) => start + index);
}

export interface PaginationProps {
  page: number;
  onChange: (page: number) => void;
  totalItems: number;
  pageSize: number;
}

export function Pagination({ page, onChange, totalItems, pageSize }: PaginationProps) {
  if (totalItems <= 0 || pageSize <= 0) return null;

  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalItems);
  const pages = getVisiblePages(page, totalPages);

  return (
    <div className="list-pagination">
      <span className="list-pagination__range">
        {from}–{to} из {totalItems}
      </span>
      {totalPages > 1 && (
        <MantinePagination.Root total={totalPages} value={page} onChange={onChange}>
          <Group gap={6}>
            <MantinePagination.First />
            {pages.map((pageNumber) => (
              <MantinePagination.Control
                key={pageNumber}
                active={pageNumber === page}
                aria-current={pageNumber === page ? 'page' : undefined}
                onClick={() => onChange(pageNumber)}
              >
                {pageNumber}
              </MantinePagination.Control>
            ))}
            <MantinePagination.Last />
          </Group>
        </MantinePagination.Root>
      )}
    </div>
  );
}
